import { Component, inject } from '@angular/core';
import { FocusService } from '@cudirect/shared-ui-library';
import { CustomModal } from '@workflow/dynamic-render/page/shared/core-custom-page.decorator';
import { WorkflowPageNavigationService } from '@workflow/service/workflow-page-navigation/workflow-page-navigation.service';
import { OaoPageHelper } from '../../helper/oao-page.helper';
import { StatefulService } from '@app/service/stateful.service';
import { OlaPageHelper } from '@workflow/ecp-workflow/ola/helper/ola-page.helper';
import { FlowInstance } from '@workflow/class/flow.service';
import { PageInstance } from '@workflow/class/page.service';

@CustomModal('oao-confirm-delete-applicant')
@Component({
  selector: 'ecp-oao-confirm-delete-applicant',
  templateUrl: './confirm-delete-applicant.component.html'
})
export class ConfirmDeleteApplicantComponent {
  private readonly statefulService = inject(StatefulService);
  public flow: FlowInstance;
  public page: PageInstance;

  public get isOAO(): boolean {
    const flowId = this.flow?.id?.toLowerCase();
    return flowId?.includes('oao');
  }

  constructor(
    public workflowPageNavigationService: WorkflowPageNavigationService,
    private readonly flowHelper: OaoPageHelper,
    private readonly olaFlowHelper: OlaPageHelper,
    private readonly focusService: FocusService
  ) {}

  public confirmDeleteApplicant = (): void => {
    /** If yes, Clearing All fields */
    if (this.isOAO) {
      this.flowHelper.removeOaoApplicant();
    } else this.olaFlowHelper.removeCoBorrowerAndGoBack('ola-add-co-applicant');
    this.statefulService.wrap('ss:showApplicantRemoveModal').value = false;
  };

  public cancelDeleteApplicant = (): void => {
    this.statefulService.wrap('ss:showApplicantRemoveModal').value = false;
    this.setFocusOnRemoveBtn();
    return;
  };

  // this sets focus back on the button that opens the modal (on the page-header component)
  public setFocusOnRemoveBtn = (): void => {
    const removeApplicantId = `remove-oao-applicant`;
    this.focusService.setFocus(removeApplicantId);
  };
}
